import './ForYou.css';
import { useParams } from 'react-router-dom';
import ribbons from '../assets/constants/ribbons.js';
import vases from '../assets/constants/vases.js';
import flowers from '../assets/constants/flowers.js';
import leafCluster from '../assets/images/leafCluster.png';
import React from "react";

function YourBouquet(props) {
    let params = useParams();

    // #TODO add checks to make sure all elements arent undefined or wrong type
    let bouquetDisplayIndex = params.display
    let bouquetRibbonIndex = params.ribbon
    let flowersArray = params.flowers.split(",")

    return (
        <div className="">
            <div className="">
                    <div className="forYouFlowers">
                        <img className="leafClusterImage" src={leafCluster} alt="green leaf cluster"/>
                        {flowersArray.map((flower, index) => (
                            <img key={index} className={"flowerForYouImageLarge flowerForYouImageLarge" + index} src={flowers[parseInt(flower)].img} alt={flowers[parseInt(flower)].name} />
                        ))}
                    </div>
                    <img className="selectedVaseForYou" src={vases[bouquetDisplayIndex].src} alt={vases[bouquetDisplayIndex].alt} />
                    <img className="selectedVaseForYou backSelectedVaseForYou" src={vases[bouquetDisplayIndex].backSrc} alt={vases[bouquetDisplayIndex].alt} />
                    <div className={"ribbonOnVaseForYou ribbonOnVaseForYou" + ribbons[bouquetRibbonIndex].type}>
                        <img className="chosenRibbonForYou outlineRibbonChosenForYou" src={ribbons[bouquetRibbonIndex].outlineSrc} alt="outline of a bow" />
                        <img className="chosenRibbonForYou" src={ribbons[bouquetRibbonIndex].src} alt={ribbons[bouquetRibbonIndex].alt} />
                    </div>
                </div>
        </div>

    )

}

export default YourBouquet;